// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3uRjA","header":"MergedInvoice_header__1XgPI"};